import { ReactNode, useState } from 'react';
import { ScrollToImageContext } from './context';

export const ScrollToImageProvider = ({ children }: { children: ReactNode }) => {
  const [newImageKey, setNewImageKey] = useState<string | null>(null);

  return (
    <ScrollToImageContext.Provider value={{ newImageKey, setNewImageKey }}>{children}</ScrollToImageContext.Provider>
  );
};
